import {Notification, NotificationGroup} from "@progress/kendo-react-notification";
import {Slide} from "@progress/kendo-react-animation";
import React, {ReactNode, useContext, useEffect, useState} from "react";
import {Button} from "@progress/kendo-react-buttons";
import {flintIconButtonProps} from "../../../controls/FlintIconButton";
import {GUID, VivoPortal} from "../../../../utils/AppConstants";
import EnumNotificationElement = VivoPortal.EnumNotificationElement;
import {FlintNotificationContext, useFlintNotificationContext} from "./FlintNotificationContext";
import {ApiError} from "../../../../utils/errors/ApiError";
import {AxiosError} from "axios";


export default function FlintNotification(props: flintIconButtonProps) {
    const [notifications, setNotifications] = useState<notificationInfo[]>([]);
    const {
        notificationText,
        notificationType,
        autohide,
        showNotification: updateNotification
    } = useFlintNotificationContext();

    function showNotification(notificationText: string, autohide: number = 5, icon: boolean, style: "none" | "info" | "success" | "warning" | "error") {
        let uniqueKey: GUID = crypto.randomUUID();
        let notification = constructNotification(notificationText, uniqueKey, notificationType ?? {
            icon: icon,
            style: style
        });
        let hideFunction = undefined;
        // Create a timeout to remove the notification after the autohide time
        let timeoutId: NodeJS.Timeout | undefined = undefined;
        if (autohide) {
            hideFunction = () => {
                let timeoutId = setTimeout(() => {
                    setNotifications(prevNotifications =>
                        prevNotifications.filter(x => x.uniqueKey !== uniqueKey)
                    );
                    clearTimeout(timeoutId);
                }, autohide! * 1000);
            };
        }
        let n = {uniqueKey, notification, autohide: hideFunction, timeoutId};
        setNotifications(prevNotifications => [...prevNotifications, n]);
        if (hideFunction)
            hideFunction();
    }

    useEffect(() => {
        if (!notificationText)
            return;
        let icon = notificationType?.icon ?? false;
        let style = notificationType?.style;
        let notifications: string[] = [];
        if (notificationText instanceof ApiError) {
            if (!style)
                style = "error";
            // notificationText is a string array
            notificationText.errorMessages.forEach(message =>
                notifications.push(message)
            );
        } else if (notificationText instanceof AxiosError) {
            if (!style)
                style = "error";
            notifications.push(notificationText.message);
        } else if (Array.isArray(notificationText)) {
            // notificationText is a string array
            notificationText.forEach(message =>
                notifications.push(message)
            );
        } else {
            // notificationText is a single string (but in case it is not, using toString method)
            notifications.push(notificationText.toString());
        }
        notifications.forEach((n) => {
            showNotification(n, autohide, icon, style ?? "none");
        })
        updateNotification('');
    }, [notificationText]);

    function constructNotification(content: ReactNode, uniqueKey: GUID, type: {
        icon?: boolean;
        style?: "none" | "info" | "success" | "warning" | "error";
    }) {
        return (
            <Notification key={uniqueKey} type={type} closable={false} children={content}/>
        )
    }

    return (<>
            <NotificationGroup style={{top: "20px", left: "50%", transform: "translateX(-50%)"}}>
                {notifications.map(x => x.notification)}
            </NotificationGroup>
        </>
    )
}

interface notificationInfo {
    uniqueKey: GUID;
    notification: ReactNode;
    autohide?: () => void | undefined;
    timeoutId?: NodeJS.Timeout;
}

export interface flintNotificationProps {
    contextKey: EnumNotificationElement; // for notification context to distinguish between different instances
}